export const isInteger = (price: number, unit = 10): boolean => {
  return Number.isInteger(price / unit)
};
export const cutOffPrice = (price: number, unit = 10): number => {
  return price - (price % unit)
};

/**
 * 재고체크
 * @param orderList 주문 리스트
 * @returns 
 */
export const checkStock = (orderList: Record<string, any>[]) => {
  let stock = true
  orderList.forEach((item) => {
    if (item.runoutPolicy && item.runoutPolicy !== 'ableStock') {
      stock = false
    }
    if (item.quantity > item.availableInventory) {
      stock = false
    }
  })
  return stock
};

export const clickClose = () => {
  const router = useRouter();

  if (document.referrer !== '') {
    controlHistoryBack(1)
  } else {
    // this.controlHistoryBack(2)
    router.go(-1)
  }
};

const controlHistoryBack = (index: number) => {
  const paymentHistory = sessionStorage.getItem('paymentHistory') as number | null;
  sessionStorage.removeItem('paymentHistory')
  if (!paymentHistory) {
    history.go(-`${index}`)
  } else {
    const backCount = (history.length - paymentHistory + index) * -1
    history.go(backCount)
  }
};
